module.exports = __webpack_public_path__ + "static/media/YB5F11_2.91779d84.jpg";